/* tslint:disable */
/* eslint-disable */
/**
 * Resource server API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AdminDto } from '../model';
/**
 * AdminsManagementControllerApi - axios parameter creator
 * @export
 */
export const AdminsManagementControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AdminDto} adminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdmin: async (adminDto: AdminDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminDto' is not null or undefined
            assertParamExists('addAdmin', 'adminDto', adminDto)
            const localVarPath = `/api/admin/manage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminsManagementControllerApi - functional programming interface
 * @export
 */
export const AdminsManagementControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminsManagementControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AdminDto} adminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addAdmin(adminDto: AdminDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => Promise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addAdmin(adminDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminsManagementControllerApi - factory interface
 * @export
 */
export const AdminsManagementControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminsManagementControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {AdminDto} adminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAdmin(adminDto: AdminDto, options?: any): Promise<void> {
            return localVarFp.addAdmin(adminDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminsManagementControllerApi - object-oriented interface
 * @export
 * @class AdminsManagementControllerApi
 * @extends {BaseAPI}
 */
export class AdminsManagementControllerApi extends BaseAPI {
    /**
     * 
     * @param {AdminDto} adminDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminsManagementControllerApi
     */
    public addAdmin(adminDto: AdminDto, options?: AxiosRequestConfig) {
        return AdminsManagementControllerApiFp(this.configuration).addAdmin(adminDto, options).then((request) => request(this.axios, this.basePath));
    }
}
